module.exports = __webpack_public_path__ + "static/media/flag-lv.931cb00e.webp";